import React from 'react';
import Modal from '../../../commonComponents/util/Modal';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import FadeErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';

import { deepEquals } from '../../../../lib/utils';

export default class SignatureAttachmentModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!deepEquals(nextProps.attachment, this.props.attachment)) {
            this.setState({ loading: true, error: false });
        }
    }

    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal attachment-modal">
                        <div className="modal-header">
                            <h4 className="page-header">{this.props.attachment.name}</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.props.close} />
                        </div>
                        {this.state.loading && <LoadingSpinner height="30" />}
                        <img className="signature-view" alt="signature"
                            src={this.props.attachment.source} onError={() => this.setState({ error: true, loading: false })} onLoad={() => this.setState({ loading: false })} />
                        <FadeErrorMessage message="Image preview could not be loaded, please try again." show={this.state.error} />
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/paymentSettings/SignatureAttachmentModal.jsx